import React from 'react'
import PropTypes from 'prop-types'
import {CategoryFilters} from '../../../../components/filters/filters'
import {BANNER_TYPES, layoutTypeEnum} from '../types'

export const CategoryFiltersBanner = ({
    attributes,
    className,
    type,
    list,
    links,
    layoutType,
    ...rest
}) => {
    return (
        <CategoryFilters
            className={className}
            attributes={attributes}
            filterType={type}
            list={list}
            links={links}
            layoutType={layoutType}
            data-testid={'filters-CategoryFilters'}
        />
    )
}

CategoryFiltersBanner.propTypes = {
    attributes: PropTypes.object,
    className: PropTypes.string,
    type: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.object),
    links: PropTypes.arrayOf(PropTypes.object),
    layoutType: PropTypes.string,
    filterType: PropTypes.string
}

export const CategoryFiltersBannerDefinition = {
    component: CategoryFiltersBanner,
    name: 'CategoryFiltersBanner',
    canHaveChildren: false,

    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: false
    },
    inputs: [
        {
            name: 'type',
            type: 'string',
            required: true,
            enum: Object.values(BANNER_TYPES),
            defaultValue: BANNER_TYPES.FILTERS
        },
        {
            name: 'layoutType',
            type: 'string',
            enum: Object.values(layoutTypeEnum),
            defaultValue: layoutTypeEnum.scroll,
            helperText: 'Choose how the filters will be displayed'
        },

        {
            name: 'list',
            type: 'list',
            showIf: `options.get('type') === '${BANNER_TYPES.FILTERS}'`,
            defaultValue: [
                {
                    'Filter Label': 'Under $25',
                    'Minimum Price': '0',
                    'Maximum Price': '25',
                    'Search parameters': ''
                },
                {
                    'Filter Label': 'Under $50',
                    'Minimum Price': '0',
                    'Maximum Price': '50',
                    'Search parameters': ''
                },
                {
                    'Filter Label': 'Under $150',
                    'Minimum Price': '0',
                    'Maximum Price': '150',
                    'Search parameters': ''
                },
                {
                    'Filter Label': 'Under $250',
                    'Minimum Price': '0',
                    'Maximum Price': '250',
                    'Search parameters': ''
                },
                {
                    'Filter Label': 'Under $350',
                    'Minimum Price': '0',
                    'Maximum Price': '350',
                    'Search parameters': ''
                },
                {
                    'Filter Label': 'Over $350',
                    'Minimum Price': '350',
                    'Maximum Price': '9999',
                    'Search parameters': ''
                }
            ],
            subFields: [
                {
                    name: 'Filter Label',
                    type: 'string',
                    defaultValue: 'Under $X'
                },
                {
                    name: 'Maximum Price',
                    type: 'string',
                    defaultValue: 'inf',
                    helperText: 'Sets pmax=x param, leave empty to ignore'
                },
                {
                    name: 'Minimum Price',
                    type: 'string',
                    defaultValue: '0',
                    helperText: 'Sets pmin=x param, leave empty to ignore'
                },
                {
                    name: 'Search parameters',
                    type: 'string',
                    defaultValue: '',
                    helperText:
                        'Parameters to append to the URL when clicking the filter link. Format: "key1=value1&key2=value2"'
                }
            ]
        },
        {
            name: 'links',
            type: 'list',
            showIf: `options.get('type') === '${BANNER_TYPES.LINK_AND_IMAGE}'`,
            subFields: [
                {
                    name: 'Label',
                    type: 'string',
                    defaultValue: ''
                },
                {
                    name: 'Link',
                    type: 'string',
                    defaultValue: '',
                    helperText:
                        'Absolute URL or relative path to the filter link. Example: "/category?filter=value"'
                },
                {
                    name: 'Image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'png']
                }
            ]
        }
    ]
}
